export var AgentAnnouncementStatusType;
(function (AgentAnnouncementStatusType) {
    AgentAnnouncementStatusType["ENABLE"] = "enable";
    AgentAnnouncementStatusType["DISABLE"] = "disable";
})(AgentAnnouncementStatusType || (AgentAnnouncementStatusType = {}));
//# sourceMappingURL=AgentAnnouncementStatusType.js.map